var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCellphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.11 11.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e1251b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pneus"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,6.76a7.58,7.58,0,0,1-1.15-.24,1.3,1.3,0,0,0-1.3.32l-.71.71A8.12,8.12,0,0,1,3.56,4.32l.71-.71A1.32,1.32,0,0,0,4.59,2.3a7.33,7.33,0,0,1-.24-1.15A1.3,1.3,0,0,0,3.06,0H1.31a1.29,1.29,0,0,0-1,.43A1.29,1.29,0,0,0,0,1.31a.49.49,0,0,0,0,.12A10.33,10.33,0,0,0,1,5,10.62,10.62,0,0,0,3.1,8a10.76,10.76,0,0,0,3,2.11,10.72,10.72,0,0,0,3.6,1,1.33,1.33,0,0,0,1-.34,1.31,1.31,0,0,0,.42-1V8.05A1.29,1.29,0,0,0,10,6.76Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellphone);
export default __webpack_public_path__ + "static/media/cellphone.e9f4b78c7a92b26fea3b1d29c78f4c6b.svg";
export { ForwardRef as ReactComponent };